import { observer } from "mobx-react-lite"
import Layout from "../../components/layout/Layout"
import { useStore } from "../../stores/root-store-context";
import { Button, Flex, Form, FormProps, Input, Modal, Popconfirm, Select, Image, Spin, Table, TableProps, Tag, Typography, message, AutoComplete, Tabs, TabsProps, Upload, GetProp, Tooltip } from "antd";
import { useEffect, useState } from "react";
import { DeleteOutlined, EditOutlined, CloseOutlined, UploadOutlined } from '@ant-design/icons';
import { useNavigate } from "react-router-dom";
import { TextSort } from "../../helpers/SorterHelper";
import { useTranslation } from "react-i18next";
import { getUserComponent } from "../../helpers/user";
import { ResourceItem } from "../../stores/ResourcesStore";
import TextArea from "antd/es/input/TextArea";
import { AddResourceGroup } from "./AddResourceGroup";
import { RcFile, UploadChangeParam, UploadFile, UploadProps } from "antd/es/upload";
import { Roles } from "../../enums/Roles";

const Search = Input.Search;


const Resource = observer(() => {
    const [form] = Form.useForm();
    const navigate = useNavigate();
    const { t } = useTranslation();

    const { applicationStore, resourceStore, employeesStore } = useStore();
    const [searchText, setSearchText] = useState("");

    const [currentFileList, setCurrentFileList] = useState<UploadFile[]>([]);


    const [isModalOpen, setIsModalOpen] = useState(false);
    const [editItem, setEditItem] = useState<ResourceItem | undefined>();

    const showModal = () => {
        setIsModalOpen(true);
    };

    const hideModal = () => {
        setEditItem(undefined);
        form.resetFields();
        setCurrentFileList([]);
        setIsModalOpen(false);
    };

    const [isModalAddGroup, setIsModalAddGroup] = useState(false);

    const showModalAddGroup = () => {
        setIsModalAddGroup(true);
    };

    const hideModalAddGroup = () => {
        setIsModalAddGroup(false);
    };

    const getUserName = (userId: string) => {
        const user = employeesStore.users?.find(el => el.id === userId);
        if (user) {
            return `${user.firstName} ${user.lastName}`
        } else {
            return ""
        }
    };

    const columns: TableProps<ResourceItem>['columns'] = [
        {
            title: `${t("Name")}`,
            dataIndex: 'title',
            key: 'title',
            render: (data, record) => <div>{record.title}</div>,
            sorter: (a: ResourceItem, b: ResourceItem) => TextSort(a.title, b.title),
            width: "20%"

        },
        {
            title: `${t("Type")}`,
            dataIndex: 'resourceGroupId',
            key: 'resourceGroupId',
            render: (data, record) => <div>{resourceStore.resourceGoups.find(el => el.id == record.resourceGroupId.toString())?.title}</div>,
            sorter: (a: ResourceItem, b: ResourceItem) => TextSort(a.resourceGroupId.toString(), b.resourceGroupId.toString()),
            width: "15%"
        },
        {
            title: `${t("Photo")}`,
            dataIndex: 'photoIds',
            key: 'photoIds',
            render: (data, record) => <Flex gap={5} wrap="wrap">
                {data?.map((el: any, index: number) => {
                    return <Image
                        key={index}
                        width={100}
                        height={100}
                        style={{ objectFit: "cover", minWidth: 100 }}
                        src={`http://res.cloudinary.com/dnl3x07wo/raw/upload/${el}`}
                    />
                })}
            </Flex>,
        },
        {
            title: `${t("User")}`,
            dataIndex: 'assignedUserId',
            key: 'assignedUserId',
            render: (data, record) => {
                if (applicationStore.user?.roles?.some(r => r.id === Roles.Owner || r.id === Roles.Manager || r.id === Roles.Financier)) {
                    return (
                        <Flex gap={5} align="center">
                            <AutoComplete
                                style={{ height: 40, width: 250 }}
                                placeholder={t("User")}
                                value={getUserName(data)}
                                onChange={(e, option: any) => {
                                    resourceStore.update(record.id as number, { assignedUserId: option?.id });
                                }}
                                options={employeesStore.users?.filter(user => user.id !== record.assignedUserId as any).map((el, index) => ({
                                    value: el.id,
                                    id: el.id, label: <Flex align="center">
                                        <Image
                                            preview={false}
                                            width={40}
                                            height={40}
                                            style={{ borderRadius: "50%", objectFit: "cover", minWidth: 40 }}
                                            src={el.photoId ? `${applicationStore?.siteConfig?.baseCloudinary}/image/upload/w_300/${el.photoId}` :
                                                `https://res.cloudinary.com/dnl3x07wo/image/upload/w_300/z03w7hlsy8hcoic9dlcn`
                                            }
                                        />
                                        <Flex vertical justify="start" gap={5} style={{ marginLeft: 20 }}>
                                            <div>{el.firstName + " " + el.lastName}</div>
                                            <div>{el.email}</div>
                                        </Flex>
                                    </Flex>
                                }))}
                            />
                            <Button disabled={!(applicationStore.user?.roles?.some(r => r.id === Roles.Owner || r.id === Roles.Admin) || applicationStore.user.id === record.assignedUserId as any)}
                                onClick={() => {
                                    resourceStore.update(record.id as number, { assignedUserId: -1 });
                                }}
                                type="default" shape="circle" icon={<DeleteOutlined />} />
                        </Flex>
                    )
                } else if (applicationStore.user?.roles?.some(r => r.id === Roles.User)) {
                    return (
                        <div>{getUserComponent(applicationStore.siteConfig.baseCloudinary, employeesStore.users.find(el => el.id === data), applicationStore.company?.Tenant, 20)}</div>
                    )
                } else {
                    return (
                        <div>{getUserComponent(applicationStore.siteConfig.baseCloudinary, employeesStore.users.find(el => el.id === data), applicationStore.company?.Tenant, 20)}</div>
                    )
                }
            },
            sorter: (a: ResourceItem, b: ResourceItem) => TextSort(a.assignedUserId as any || "", b.assignedUserId as any || ""),
            width: "20%"

        },
        {
            title: '',
            dataIndex: 'operation',
            render: (_: any, record: ResourceItem) => {
                console.log(record)
                if (!applicationStore.user?.roles?.some(r => r.id === Roles.Owner || r.id === Roles.Manager || r.id === Roles.Financier || r.id === Roles.Admin)) {
                    return <></>
                }
                return (
                    <>
                        <Flex justify="space-between" gap={10}>
                            <Button type="primary" shape="circle" onClick={async () => {
                                setEditItem(record);
                                form.setFieldsValue(record);
                                setIsModalOpen(true);
                            }} icon={<EditOutlined />} />
                            <Popconfirm

                                title={t("DeleteItem")}
                                description={t("DeleteConfirmation", { name: record.title })}
                                okText={t("Yes")}
                                cancelText={t("No")}
                                onConfirm={async () => {
                                    try {
                                        await resourceStore.deleteById(record.id as number);
                                        message.success(t("RemoveSuccess"));
                                    } catch (error) {
                                        message.error("Failed!");
                                    }
                                }}
                            >
                                <Button disabled={
                                    !(applicationStore.user?.roles?.some(r => r.id === Roles.Owner || r.id === Roles.Manager || r.id === Roles.Admin))
                                } type="primary" danger shape="circle" icon={<DeleteOutlined />} />
                            </Popconfirm>
                        </Flex>

                    </>
                );


            },
        }
    ];


    const Add: FormProps<ResourceItem>['onFinish'] = async (item: ResourceItem) => {
        message.open({
            type: 'loading',
            content: t("Saving"),
            key: 'Saving'
        });
        const withOutPhotos = { ...item, photoIds: [] };
        resourceStore.createNew(withOutPhotos).then(async (res) => {
            resourceStore.setLoading(true);
            const photoIds: string[] = [];
            for (const file of currentFileList) {
                const originFileObj: any = file.originFileObj;
                try {
                    const uploadFile: any = await resourceStore.uploadFile(originFileObj, res.value.id);
                    photoIds.push(uploadFile.public_id);
                } catch (error) {
                    console.log(error);
                }
            }
            const newItem = { photoIds: photoIds };
            try {
                await resourceStore.update(res.value.id, newItem as any);
                message.destroy("Saving");
                message.success(t("Successfully saved"));
                form.resetFields();
                hideModal();
            } catch (error) {
                console.log(error);
            }

        }).catch(error => {
            message.destroy("invitation");
            message.error(error.message);
        })
    };

    const Edit: FormProps<ResourceItem>['onFinish'] = async (item: ResourceItem) => {
        message.open({
            type: 'loading',
            content: t("Saving"),
            key: 'Saving'
        });
        if (editItem?.id === undefined) return;

        const id: number = editItem?.id as number;

        resourceStore.update(editItem?.id, editItem).then(async (res) => {
            resourceStore.setLoading(true);
            const photoIds: string[] = editItem?.photoIds || [];
            for (const file of currentFileList) {
                const originFileObj: any = file.originFileObj;
                try {
                    const uploadFile: any = await resourceStore.uploadFile(originFileObj, id.toString());
                    photoIds.push(uploadFile.public_id);
                } catch (error) {
                    console.log(error);
                }
            }
            const newItem = { photoIds: photoIds };
            try {
                await resourceStore.update(id, newItem as any);
                message.destroy("Saving");
                message.success(t("Successfully saved"));
                form.resetFields();
                hideModal();
            } catch (error) {
                console.log(error);
            }

        }).catch(error => {
            message.destroy("invitation");
            message.error(error.message);
        })
    };

    useEffect(() => {
        if (employeesStore.users.length === 0) {
            employeesStore.getUsers()
        }
        resourceStore.getAllGroups().then(() => {
            resourceStore.getAllResource().catch(console.log);
        }).catch(console.log);

    }, [])

    useEffect(() => {
        let data = employeesStore.users;
        if (searchText.length > 0) {
            data = data.filter(el =>
                el.firstName?.toLowerCase().includes(searchText.toLowerCase()) ||
                el.lastName?.toLowerCase().includes(searchText.toLowerCase()) ||
                el.email?.toLowerCase().includes(searchText.toLowerCase())
            );
        }
        data = data.filter(el => el.isActive !== false);
        data = data.map(el => { return { ...el, key: el.id } });
    }, [employeesStore.users, searchText]);

    useEffect(() => {

    }, [resourceStore.resources]);

    const handleChange: UploadProps['onChange'] = (info: UploadChangeParam<UploadFile>) => {
        let fileList = [...info.fileList];
        setCurrentFileList(fileList);
    };

    const beforeUpload = (file: RcFile, allFiles: UploadFile[]) => {
        const isLt2M = file.size / 1024 / 1024 < 10;
        if (!isLt2M) {
            message.error('Image must smaller than 10MB!');
        }
        console.log(file);

        return isLt2M;
    };


    const handleUpload = async ({ file, onSuccess, onError }: any) => {
        onSuccess("ok");
    }

    const [previewOpen, setPreviewOpen] = useState(false);
    const [previewImage, setPreviewImage] = useState('');
    type FileType = Parameters<GetProp<UploadProps, 'beforeUpload'>>[0];
    const getBase64 = (file: FileType): Promise<string> =>
        new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result as string);
            reader.onerror = (error) => reject(error);
        });

    const handlePreview = async (file: UploadFile) => {
        if (!file.url && !file.preview) {
            file.preview = await getBase64(file.originFileObj as FileType);
        }
        setPreviewImage(file.url || (file.preview as string));
        setPreviewOpen(true);
    };

    return (
        <Layout headerStyle={1} footerStyle={2} breadcrumbTitle={`${t("Resource")}`}>
            <div className="container" style={{ margin: "20px auto" }}>
                <Spin spinning={employeesStore.isLoading || resourceStore.isLoading}>
                    {applicationStore.isFreezeModalVisible ? (
                        <p style={{ padding: '20px', textAlign: 'center' }}>Access to users is limited until the subscription is renewed.</p>
                    ) : (
                        <>
                            <Flex justify="space-between" style={{ marginBottom: 10 }}>
                                <Button style={{ marginLeft: "10px" }} onClick={() => {
                                    navigate(-1)
                                }} type="primary">{t("Back")}</Button>
                                <div>
                                    {applicationStore.user?.roles?.some(r => r.id === Roles.Owner || r.id === Roles.Manager || r.id === Roles.Financier || r.id === Roles.Admin) ?
                                        <Button type="primary" style={{ float: "right", marginBottom: 20, borderRadius: 0, }} onClick={showModal}>
                                            {`${t("AddResource")}`} <i className="fa-solid fa-plus" />
                                        </Button> : <></>
                                    }
                                </div>
                            </Flex>
                            <Table loading={false} columns={columns} dataSource={resourceStore.resources} onRow={(record) => ({
                                // style: record.assignedUserId === 0 ? {
                                //     backgroundColor: '#c6c6c6',
                                //     cursor: "not-allowed",
                                //     pointerEvents: 'stroke'
                                // } : {},
                            })}
                                pagination={{ pageSize: 100 }}
                            />
                        </>
                    )}
                </Spin>
            </div>

            <Modal title={editItem ? t("EditThisRecord") : t("AddResource")} open={isModalOpen} footer={null} onCancel={hideModal}>
                <Form form={form} onFinish={editItem ? Edit : Add} initialValues={editItem === undefined ? {} : editItem} labelCol={{ span: 24 }}>
                    <Form.Item<any> name="chiefId" hidden >
                        <Input />
                    </Form.Item>
                    <Form.Item<ResourceItem> label={t("Title")} name="title" style={{ width: "100%" }} rules={[{ required: true }]} >
                        <Input placeholder="Name" />
                    </Form.Item>
                    <Form.Item<ResourceItem> label={t("Description")} name="description" style={{ width: "100%" }} rules={[{ required: true }]} >
                        <TextArea placeholder="Description" rows={5} />
                    </Form.Item>
                    <Form.Item<ResourceItem> label={t("Group")} name="resourceGroupId" style={{ width: "100%" }} rules={[{ required: true }]} >
                        <Select
                            optionRender={(el) => {
                                return <div style={{ display: 'flex', width: "100%", justifyContent: "space-between" }}>
                                    <div>{el.label}</div>
                                    {el.key !== "create-new" && <Button type="primary" danger shape="circle" icon={<DeleteOutlined />} />}
                                </div>
                            }}
                            onChange={(value, option: any) => {
                                if (option?.value && option?.value !== "create-new") {
                                } else {
                                    form.setFieldValue("resourceGroupId", null);
                                }
                            }}
                            options={[...resourceStore.resourceGoups.map(el => {
                                return {
                                    label: el.title,
                                    value: el.id,
                                    key: el.id
                                }
                            }),
                            {
                                key: "create-new",
                                value: "create-new",
                                label: <Button onClick={showModalAddGroup}>{t("Add")}</Button>,
                            },
                            ]} />
                    </Form.Item>
                    <Form.Item<ResourceItem> label={t("Photos")} name={"photoIds"} style={{ width: "100%" }}  >
                        <Spin spinning={resourceStore.isLoading}>
                            <Upload
                                fileList={currentFileList}
                                onChange={handleChange}
                                listType="picture-card"
                                multiple
                                maxCount={7 - ((editItem && editItem?.photoIds ? editItem?.photoIds?.length : 0 + currentFileList.length))}
                                customRequest={handleUpload}
                                beforeUpload={beforeUpload}
                                onPreview={handlePreview}
                            >
                                {((editItem && editItem?.photoIds ? editItem?.photoIds?.length : 0) + currentFileList.length) >= 7 ? null : <Button icon={<UploadOutlined />}></Button>}

                            </Upload>
                            <Flex gap={5} wrap="wrap" >
                                {
                                    editItem?.photoIds?.map((el, index) => {
                                        return <Flex gap={20} style={{ marginTop: 20 }}>
                                            <Image
                                                key={index}
                                                width={100}
                                                style={{ minWidth: 100, marginBottom: 40 }}
                                                src={`http://res.cloudinary.com/dnl3x07wo/raw/upload/${el}`}
                                            />
                                            <Tooltip title="Видалити">
                                                <Button
                                                    type="default"
                                                    icon={<CloseOutlined style={{ color: "red" }} />}
                                                    style={{
                                                        bottom: 20,
                                                        right: 30,
                                                        background: "none",
                                                        borderRadius: "50%",
                                                        boxShadow: "none",
                                                        border: "none",
                                                    }}
                                                    onClick={() => {
                                                        setEditItem({ ...editItem, photoIds: editItem?.photoIds?.filter((el, i) => i !== index) });
                                                        form.setFieldValue("photoIds", editItem?.photoIds?.filter((el, i) => i !== index));
                                                    }}
                                                />
                                            </Tooltip>
                                        </Flex>
                                    })
                                }
                            </Flex>
                            {previewImage && (
                                <Image
                                    wrapperStyle={{ display: 'none' }}
                                    preview={{
                                        visible: previewOpen,
                                        onVisibleChange: (visible) => setPreviewOpen(visible),
                                        afterOpenChange: (visible) => !visible && setPreviewImage(''),
                                    }}
                                    src={previewImage}
                                />
                            )}
                        </Spin>
                    </Form.Item>
                    <Form.Item>
                        <Button type="primary" className="theme-btn" htmlType="submit" style={{ height: 65, float: "right" }}>
                            {editItem ? t("Save") : `${t("Add")}`} <i className="fa-solid fa-arrow-right-long" />
                        </Button>
                    </Form.Item>
                </Form>
            </Modal>
            <AddResourceGroup isModalOpen={isModalAddGroup} hideModal={hideModalAddGroup} setCallBackId={(id: number) => {
                form.setFieldValue("resourceGroupId", id);
            }} />

        </Layout>
    )
})
export default Resource;